import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { IdName } from 'src/app/shared/models/id-name';
import { IProductCategory } from '../models/product-category.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class ProductCategoryApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Product/Categories`;
  }

  constructor(private http: HttpClient) {}

  loadProductCategories(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IProductCategory[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IProductCategory[]>>(this.url, { params });
  }

  loadProductCategoriesList(): Observable<IdName[]> {
    const url = `${this.url}/List`;
    return this.http.get<IdName[]>(url);
  }

  loadProductCategoryById(id: string): Observable<IProductCategory> {
    const url = `${this.url}/${id}`;
    return this.http.get<IProductCategory>(url);
  }

  createProductCategory(productCategory: IProductCategory): Observable<IProductCategory> {
    return this.http.post<IProductCategory>(this.url, productCategory, { headers });
  }

  updateProductCategory(productCategory: IProductCategory): Observable<IProductCategory> {
    const url = `${this.url}/${productCategory.id}`;
    return this.http.put<IProductCategory>(url, productCategory, { headers });
  }

  deleteProductCategory(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
